export const SEARCH_RESIDENT_GROUP = "app/ResidentGroup/SEARCH_RESIDENT_GROUP";
export const SEARCH_RESIDENT_GROUP_SUCCESS =
  "app/ResidentGroup/SEARCH_RESIDENT_GROUP_SUCCESS";
export const SEARCH_RESIDENT_GROUP_FAILURE =
  "app/ResidentGroup/SEARCH_RESIDENT_GROUP_FAILURE";

export const FETCH_RESIDENT_GROUP = "app/ResidentGroup/FETCH_RESIDENT_GROUP";
export const FETCH_RESIDENT_GROUP_SUCCESS =
  "app/ResidentGroup/FETCH_RESIDENT_GROUP_SUCCESS";
export const FETCH_RESIDENT_GROUP_FAILURE =
  "app/ResidentGroup/FETCH_RESIDENT_GROUP_FAILURE";

export const ADD_RESIDENT_GROUP = "app/ResidentGroup/ADD_RESIDENT_GROUP";
export const ADD_RESIDENT_GROUP_SUCCESS =
  "app/ResidentGroup/ADD_RESIDENT_GROUP_SUCCESS";
export const ADD_RESIDENT_GROUP_FAILURE =
  "app/ResidentGroup/ADD_RESIDENT_GROUP_FAILURE";

export const FETCH_RESIDENT_GROUP_ITEM =
  "app/ResidentGroup/FETCH_RESIDENT_GROUP_ITEM";
export const FETCH_RESIDENT_GROUP_ITEM_SUCCESS =
  "app/ResidentGroup/FETCH_RESIDENT_GROUP_ITEM_SUCCESS";
export const FETCH_RESIDENT_GROUP_ITEM_FAILURE =
  "app/ResidentGroup/FETCH_RESIDENT_GROUP_ITEM_FAILURE";

export const EDIT_RESIDENT_GROUP = "app/ResidentGroup/EDIT_RESIDENT_GROUP";
export const EDIT_RESIDENT_GROUP_SUCCESS =
  "app/ResidentGroup/EDIT_RESIDENT_GROUP_SUCCESS";
export const EDIT_RESIDENT_GROUP_FAILURE =
  "app/ResidentGroup/EDIT_RESIDENT_GROUP_FAILURE";

export const DELETE_RESIDENT_GROUP = "app/ResidentGroup/DELETE_RESIDENT_GROUP";
export const DELETE_RESIDENT_GROUP_SUCCESS =
  "app/ResidentGroup/DELETE_RESIDENT_GROUP_SUCCESS";
export const DELETE_RESIDENT_GROUP_FAILURE =
  "app/ResidentGroup/DELETE_RESIDENT_GROUP_FAILURE";

export const SET_RESIDENT_GROUP_ADD_EDIT_MODAL =
  "app/ResidentGroup/SET_RESIDENT_GROUP_ADD_EDIT_MODAL";
